<template>
  <ListOptions
    :checked="checked"
    :isEmptySelectProduct="isEmptySelectProduct"
    :isAllSelectProduct="isAllSelectProduct"
    :onAllCheck="onAllCheck"
    :onAllDelete="onAllDelete"
  />
</template>

<script>
import ListOptions from '@/presentationals/v2/components/layouts/organisms/ListOptions'
import { ProductType } from '@/models/Product/Product'
import _ from 'lodash'

import { LogScreenName, LogType, LogGroup, LogEvent } from '@/plugins/AppLogManager'

export default {
  name: 'CartListOptionsContainer',
  components: {
    ListOptions
  },
  computed: {
    isEmptySelectProduct() {
      return this.$store.getters['cart/isEmptySelectProduct']
    },
    isAllSelectProduct() {
      return this.$store.getters['cart/isAllSelectProduct']
    }
  },
  watch: {
    isAllSelectProduct(value) {
      this.checked = value
    }
  },
  // updated() {
  //   // if (!this.isAllSelectProduct) {
  //   //   this.checked = false
  //   // } else {
  //   //   this.checked = true
  //   // }
  // },
  methods: {
    allCheckLog() {
      const params = {
        Select: this.checked,
        ShopNo: this.$store.getters['baeminShopNo']
      }

      // M1-3
      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_CART,
        type: LogType.CLICK,
        group: LogGroup.CART_DET,
        event: LogEvent.ALL_SELECT,
        params
      })
    },

    onAllCheck() {
      this.checked = !this.checked
      this.$store.commit('cart/selectAllProducts', this.checked)
      this.allCheckLog()
    },

    allDeleteLog() {
      const params = {
        ShopNo: this.$store.getters['baeminShopNo']
      }

      // M1-4
      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_CART,
        type: LogType.CLICK,
        group: LogGroup.CART_DET,
        event: LogEvent.DELETE,
        params
      })
    },

    async onAllDelete() {
      this.allDeleteLog()
      // alert(this.isEmptySelectProduct)
      // if (this.isEmptySelectProduct) return
      const isCheckedProduct = this.$store.getters['cart/checkedCartProducts'].length === 0
      if (isCheckedProduct) return

      const message = '선택 항목을 모두 삭제하시겠습니까?'
      const confirmFunction = async () => {
        const checkedProducts = this.$store.getters['cart/checkedCartProducts']

        const result = await this.$store.dispatch('cart/removeProducts', checkedProducts)
        if (!result) return

        checkedProducts.forEach(product => {
          if (product.getType() > ProductType.SINGLE)
            this.$store.commit('cart/removeProduct', product.getId())
          else {
            product.items.forEach(item => {
              this.$store.commit('cart/removeItem', {
                productId: product.getId(),
                itemId: item.getId()
              })
            })
          }
        })
      }

      if (this.$store.getters.isAndroid) {
        const isConfirm = confirm(message)
        if (isConfirm && _.isFunction(confirmFunction)) {
          await confirmFunction()
          this.allDeleteLog()
        }

        return
      }

      this.$store.dispatch('modal/open', {
        type: 'Confirm',
        message,
        onOK: async () => {
          this.$store.dispatch('modal/close')
          await confirmFunction()
          this.allDeleteLog()
        },
        onCancel: () => {
          this.$store.dispatch('modal/close')
        }
      })
    }
  },
  data() {
    return {
      checked: true
    }
  }
}
</script>
